import { render, staticRenderFns } from "./veSbzcZcRevertShow.vue?vue&type=template&id=a1c5d110&scoped=true"
import script from "./veSbzcZcRevertShow.vue?vue&type=script&lang=js"
export * from "./veSbzcZcRevertShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c5d110",
  null
  
)

export default component.exports